var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "base-info-container" },
    [
      _c(
        "el-card",
        {
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function() {
                return [_c("TitleItem", { attrs: { title: "基本信息" } })]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "el-form",
            {
              ref: "baseInfoForm",
              attrs: {
                model: _vm.baseInfoModel,
                rules: _vm.rules,
                "label-width": "125px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "商品分类", required: "" } },
                [
                  _vm.cateModel
                    ? [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.cateModel.classificationFullName) + "  "
                          )
                        ]),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: { click: _vm.changeCate }
                          },
                          [_vm._v(" 修改类目")]
                        )
                      ]
                    : _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: { click: _vm.changeCate }
                        },
                        [_vm._v("选择类目")]
                      ),
                  _c("p", { staticClass: "cate-tips" }, [
                    _vm._v(
                      "准确选择货品分类有助于完善货品信息和精准推送到商城分类"
                    )
                  ])
                ],
                2
              ),
              _c(
                "el-form-item",
                { attrs: { label: "商品名称", prop: "name" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "453px" },
                    attrs: {
                      maxlength: "30",
                      placeholder: "请输入商品名称(至多30字)"
                    },
                    model: {
                      value: _vm.baseInfoModel.name,
                      callback: function($$v) {
                        _vm.$set(_vm.baseInfoModel, "name", $$v)
                      },
                      expression: "baseInfoModel.name"
                    }
                  })
                ],
                1
              ),
              _vm.isShowOA &&
              _vm.qlwGoodsName &&
              _vm.qlwGoodsName[0] &&
              _vm.qlwGoodsName[0].name
                ? _c("el-form-item", { attrs: { label: "代号名称" } }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.qlwGoodsName[0].name) +
                        "\n      "
                    )
                  ])
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "卖点分享" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "453px" },
                    attrs: { maxlength: "30", placeholder: "请填写卖点分享" },
                    model: {
                      value: _vm.baseInfoModel.shareInfo,
                      callback: function($$v) {
                        _vm.$set(_vm.baseInfoModel, "shareInfo", $$v)
                      },
                      expression: "baseInfoModel.shareInfo"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "自定义分类" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择自定义分类" },
                      model: {
                        value: _vm.baseInfoModel.goodsType,
                        callback: function($$v) {
                          _vm.$set(_vm.baseInfoModel, "goodsType", $$v)
                        },
                        expression: "baseInfoModel.goodsType"
                      }
                    },
                    _vm._l(_vm.customCateList, function(cateItem) {
                      return _c("el-option", {
                        key: cateItem.shopDecorateId,
                        attrs: {
                          label: cateItem.name,
                          value: cateItem.shopDecorateId
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm.isShowOA
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { label: "是否企联网货品", required: "" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.baseInfoModel.isoa,
                              callback: function($$v) {
                                _vm.$set(_vm.baseInfoModel, "isoa", $$v)
                              },
                              expression: "baseInfoModel.isoa"
                            }
                          },
                          [
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v("是")
                            ]),
                            _c("el-radio", { attrs: { label: 0 } }, [
                              _vm._v("否")
                            ])
                          ],
                          1
                        ),
                        _vm.baseInfoModel.isoa == 0
                          ? _c("span", { staticClass: "cate-tips" }, [
                              _vm._v(
                                "   修改为非企联网商品后,下次编辑请不要改动规格属性,避免企联网代号关系错乱"
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                : _vm._e()
            ],
            2
          )
        ],
        1
      ),
      _vm.showSelectCate
        ? _c("SelectCateDialog", {
            attrs: { showSelectCate: _vm.showSelectCate },
            on: {
              "update:showSelectCate": function($event) {
                _vm.showSelectCate = $event
              },
              "update:show-select-cate": function($event) {
                _vm.showSelectCate = $event
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }